import React from 'react'
function Title(p) {
  return (
    <div>
<div class="three">
  <h1 className='h1'>{p.title}</h1>
</div>
    </div>
  )
}

export default Title
